/**
 * @generated SignedSource<<ab8cdea2cfa96162345b28a6aabd8366>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TemplateVisibility = "GLOBAL" | "HIDDEN" | "USER" | "WORKSPACE";
import { FragmentRefs } from "relay-runtime";
export type GridElementTemplate$data = {
  readonly id: string;
  readonly starred: boolean;
  readonly viewerCanEdit: boolean;
  readonly visibility: TemplateVisibility;
  readonly " $fragmentSpreads": FragmentRefs<"TemplateCardFullsizeNoteTemplate">;
  readonly " $fragmentType": "GridElementTemplate";
};
export type GridElementTemplate$key = {
  readonly " $data"?: GridElementTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"GridElementTemplate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GridElementTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "starred",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TemplateCardFullsizeNoteTemplate"
    }
  ],
  "type": "NoteTemplateNode",
  "abstractKey": null
};

(node as any).hash = "a5af6833e0d18e10165b42acc7d8005b";

export default node;
